import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="users--menue"
export default class extends Controller {
  static targets = [
    "menue"
  ]

  toggle(_) {
    this.menueTarget.classList.toggle("hidden")
  }
}
